import { Tag } from 'antd';
import { FOLIO_STATUS } from '@/interfaces/Folio';
import useCustomTranslation from '@/hooks/useCustomTranslation';

const STATUS_COLOR: Record<FOLIO_STATUS, string> = {
  [FOLIO_STATUS.BLANK]: 'default',
  [FOLIO_STATUS.ACTIVE]: 'green',
  [FOLIO_STATUS.PACKAGED]: 'blue',
  [FOLIO_STATUS.SOLD]: 'gold',
  [FOLIO_STATUS.WASTED]: 'red',
};

interface FolioStatusTagProps {
  status: FOLIO_STATUS;
}

const FolioStatusTag = ({ status }: FolioStatusTagProps) => {
  const { t } = useCustomTranslation();
  return (
    <Tag color={STATUS_COLOR[status]}>
      {t(`g.folio_status.${status}`)}
    </Tag>
  );
};

export default FolioStatusTag;
